import React, { useState, useEffect } from "react";
import HeroTitle from '../../components/hero/herotitle'
import ImageSlider from '../../components/hero/imageslider'
import { Link } from 'react-scroll'
import Services from '../../api/service'

const Hero =() => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % Services.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="tp-hero-section-1">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-7 col-lg-7">
                        <div className="tp-hero-section-text">
                            <HeroTitle activeIndex={activeIndex} />
                            <div className="tp-hero-sub">
                                <p>Abdul Cholik Studio</p>
                            </div>
                            <div className="btns">
                                <Link activeClass="active" to="contact" spy={true} smooth={true} duration={500} offset={-95} className="theme-btn">Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right-vec">
                <div className="right-img">
                    <ImageSlider activeIndex={activeIndex} />
                </div>
            </div>
            <div className="visible-text">
                <h1>Abdul Cholik Studio</h1>
            </div>
        </section>
    )
}

export default Hero;